export default {
    data: {
        emptyObj: {name: ''}
    },
    fitJRegion(object) {
        let emptyObj = this.data.emptyObj;
        if (typeof object.j_region === 'string') {
            try {
                object.j_region = JSON.parse(object.j_region);
            } catch (e) {
                object.j_region = {};
            }
        }
        object.j_region = object.j_region || {};
        object.j_region.province = object.j_region.province || emptyObj;
        object.j_region.city = object.j_region.city || emptyObj;
        object.j_region.area = object.j_region.area || emptyObj;
    },
    fitJLocation(object) {
        let emptyObj = this.data.emptyObj;
        if (typeof object.j_location === 'string') {
            try {
                object.j_location = JSON.parse(object.j_location);
            } catch (e) {
                object.j_location = {};
            }
        }
        object.j_location = object.j_location || {};
        object.j_location.building = object.j_location.building || emptyObj;
        object.j_location.unit = object.j_location.unit || emptyObj;
        object.j_location.door = object.j_location.door || emptyObj;
    }
}